module.exports = "../../static/fonts/Lato-BlackItalic.6c522f0.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-BlackItalic.ttf
// module id = 919
// module chunks = 2